(function($){

  $('#slider-profile-1').bxSlider({
    slideWidth: 196,
    slideMargin: 30,
    pager: false,
    auto: false,
    nextSelector: '#slider-next-1',
    prevSelector: '#slider-prev-1',
    nextText: '<i class="fa-thin fa-2x fa-chevron-down"></i>',
    prevText: '<i class="fa-thin fa-2x fa-chevron-up"></i>',
    mode: 'vertical',
    captions: true
  });

  $('#slider-profile-2').bxSlider({
    slideWidth: 196,
    slideMargin: 30,
    pager: false,
    auto: false,
    nextSelector: '#slider-next-2',
    prevSelector: '#slider-prev-2',
    nextText: '<i class="fa-thin fa-2x fa-chevron-down"></i>',
    prevText: '<i class="fa-thin fa-2x fa-chevron-up"></i>',
    mode: 'vertical',
    captions: true
  });

  $('#slider-profile-3').bxSlider({
    slideWidth: 196,
    slideMargin: 30,
    pager: false,
    auto: false,
    nextSelector: '#slider-next-3',
    prevSelector: '#slider-prev-3',
    nextText: '<i class="fa-thin fa-2x fa-chevron-down"></i>',
    prevText: '<i class="fa-thin fa-2x fa-chevron-up"></i>',
    mode: 'vertical',
    captions: true
  });

  $('.Profiles').on('click', '.profileBtn', function(){
    var reqTif = '';
    $.each($('.Profiles li[aria-hidden=false]'), function() {
      reqTif = reqTif + '~' + $(this).data('tif');
    });
    reqTif = reqTif.substring(1, reqTif.length);

    document.location.href=base_url + '/' + lang_url + '/profile/?reqTif=' + reqTif;
  });

})(jQuery);